import React, { ReactElement } from 'react';
import { Box } from '@mui/material';

import alyceLogo from '../../assets/images/full-logo.svg';

const Header = (): ReactElement => (
  <Box data-testid="headerBox" width={1}>
    <img src={alyceLogo} alt="Alyce logo" />
  </Box>
);

export default Header;
